import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";

const formDataSupport = [
  {
    formFields: [
      {
        fieldLabel: "First Name",
        fieldType: "text",
        fieldName: "firstName",
        required: true,
      },
      {
        fieldLabel: "Last Name",
        fieldType: "text",
        fieldName: "lastName",
        required: true,
      },
      {
        fieldLabel: "Email",
        fieldType: "email",
        fieldName: "email",
        required: true,
      },
      {
        fieldLabel: "Organization",
        fieldType: "text",
        fieldName: "organization",
        required: false,
      },
      {
        fieldLabel: "Role",
        fieldType: "text",
        fieldName: "role",
        required: false,
      },
      {
        fieldLabel: "Zip/Postal Code",
        fieldType: "text",
        fieldName: "zipCode",
        required: true,
      },
    ],
    formChecks: [
      {
        checkLabel: "Share learnings from the scorecard tests to improve it",
        checkType: "checkbox",
        checkName: "share-learnings",
      },
      {
        checkLabel: "Volunteer time individually or as a team deployment",
        checkType: "checkbox",
        checkName: "volunteerTime",
      },
      {
        checkLabel: "Subject matter experts",
        checkType: "checkbox",
        checkName: "subjectMatterExpertise",
      },
      {
        checkLabel: "Datasets and / or computer systems capacity",
        checkType: "checkbox",
        checkName: "dataOrCompute",
      },
      {
        checkLabel: "Sponsorships and other in-kind support",
        checkType: "checkbox",
        checkName: "sponsorOrInKind",
      },
      {
        checkLabel: "Funding",
        checkType: "checkbox",
        checkName: "funding",
      },
      {
        checkLabel: "Other",
        checkType: "checkbox",
        checkName: "otherSupport",
        formTextarea: {
          textareaLabel: "Message",
          textareaName: "message",
        },
      },
    ],
  },
];

const PopUpScorecardFormContribute = ({ onClose, onSuccess, onError }) => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value })); // Dynamically update state
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    const dataToSend = {
      ...formData,
      scorecardForm: true,
    };

    try {
      const response = await axios.post(
        `${baseURL}/api/submit-support-form`,
        dataToSend,
        {
          withCredentials: "true", // This matches the backend CORS policy
          headers: { "Content-Type": "application/json" },
        }
      );
      if (response.status === 200) {
        onSuccess("support");
        onClose();
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <>
      <div className="pop-up-form">
        <div className="form-header">
          <h4>Support Wildfire Prevention</h4>
          <div className="close-btn-x" onClick={onClose}>
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <form id="supportCauseForm" onSubmit={handleSubmit}>
          <p>
            {" "}
            Providing your contact information enables us to share best
            practices, communicate updates, and network with our global wildfire
            prevention community.
          </p>
          {formDataSupport &&
            formDataSupport[0].formFields.map((item) => (
              <div className="form-group">
                <label for={`${item.fieldName}`} aria-required="true">
                  {item.required && "* "} {item.fieldLabel}
                </label>
                <input
                  type={`${item.fieldType}`}
                  id={`${item.fieldName}`}
                  name={`${item.fieldName}`}
                  onChange={handleChange}
                  value={formData[item.fieldName] || ""}
                  required={item.required}
                />
              </div>
            ))}
          <div>
            <h5>
              Support the Wildfire Scorecard and Catastrophic Prevention Efforts
            </h5>
            <p>
              I or my organization are interested in supporting the Catastrophic
              Wildfire Prevention Consortium at CrowdDoing venture in the
              following ways:
            </p>
          </div>
          {formDataSupport &&
            formDataSupport[0].formChecks.map((item) => (
              <div className="form-check">
                <input
                  type={`${item.checkType}`}
                  id={`${item.checkName}`}
                  name={`${item.checkName}`}
                  onChange={handleChange}
                  value={formData[item.checkName]}
                />
                <label for={`${item.checkName}`}>{item.checkLabel} </label>
                {item.checkName.startsWith("other") && (
                  <div class="form-group textarea">
                    <label for={`${item.formTextarea.textareaName}`}>
                      {item.formTextarea.textareaLabel}
                    </label>
                    <textarea
                      id={`${item.formTextarea.textareaName}`}
                      name={`${item.formTextarea.textareaName}`}
                      cols="50"
                      onChange={handleChange}
                      value={formData[item.textareaName]}
                    ></textarea>
                  </div>
                )}
              </div>
            ))}

          <div className="form-check">
            <input
              type="checkbox"
              id="subscribe"
              name="subscribe"
              onChange={handleChange}
              value={formData.subscribe || ""}
            />
            <label for="subscribe">Subscribe</label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="pilot"
              name="pilot"
              onChange={handleChange}
              value={formData.pilot || ""}
            />
            <label for="pilot">I'm interested in piloting with CWPC</label>
          </div>
          <Button
            text="Support Cause"
            color="var(--green)"
            className="pop-up-btn"
          ></Button>
        </form>

        <div className="policy">
          <PolicyContainer text="Support Cause" />
        </div>
        <div className="form-footer">
          <div className="form-close-btn" onClick={onClose}>
            Close
          </div>
        </div>
      </div>
    </>
  );
};

export default PopUpScorecardFormContribute;
